( function( global, $ ) {
    var $bundle = $('[gr-bundle]'),
        $bundleDownload = $('.bundle-download');

    $bundle.on('click', 'input[type=checkbox]', function() {
        $(this).closest('.card').toggleClass('is-selected');

        if ( $('.card.is-selected').length === 0 ) {
            $bundleDownload.find('.btn--primary').attr('disabled', '');
        } else {
            $bundleDownload.find('.btn--primary').removeAttr('disabled');
        }

        $bundleDownload.find('.bundle-download__counter span').attr('data-counter', $('.card.is-selected').length);
    });

    // $bundle.on('click', '.card__cover', function() {
    //     $(this).next().find('input[type=checkbox]').trigger('click');
    // });

    $('.js-downloadImages').click(function(){
        $(this).closest('form').submit();
    });
}( window.groots, jQuery ));
